import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.climbStepTwoExtraCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.climbStepTwoExtraCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) =>
    state.climbStepTwoExtraCollections.data.climbStepTwoExtraCollections,
  (collections = []) => collections
);
const getPageCount = createSelector(
  (state) => state.climbStepTwoExtraCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getHasLoaded,
  getPageCount,
};
